/** 在新标签打开某店铺自己的 Shopify 后台。 */
export function openShopifyAdmin(shopDomain: string): void {
  window.open(`https://${shopDomain}/admin`, "_blank", "noopener,noreferrer");
}
